export const ONLY_NUMBERS = /^[0-9]*$/
export const ONLY_LETTERS = /^[A-Za-z]+$/
export const ONLY_LETTERS_NUMBERS_AMPERSAND_ACCENTS_SPACE_AND_DASH = /^[ a-zA-ZàâäéèêëîïôöùûüÿçÀÂÄÉÈÊËÎÏÔÖÙÛÜŸÇ&\-\d]*$/
export const ONLY_LETTERS_NUMBERS_AMPERSAND_ACCENTS_ESZETT_SPACE_AND_DASH =
  /^[ a-zA-ZàâäéèêëîïôöùûüÿçÀÂÄÉÈÊËÎÏÔÖÙÛÜŸÇ&ß\-\d]*$/
